var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "eligibility-tags" },
    _vm._l(_vm.services, function (name) {
      return _c(
        "el-popover",
        { key: name, attrs: { placement: "left", trigger: "hover" } },
        [
          [
            _c("EligibilityReasons", {
              attrs: {
                reasons: _vm.eligibility[name].ineligibilityReasons || [],
                service: name,
              },
            }),
            _vm._v(" "),
            _c(
              "el-tag",
              {
                staticStyle: {
                  "margin-right": "3px",
                  "margin-bottom": "3px",
                  cursor: "help",
                },
                attrs: {
                  slot: "reference",
                  size: "mini",
                  type: _vm.tagTypeFor(name),
                },
                slot: "reference",
              },
              [_vm._v("\n        " + _vm._s(name) + "\n      ")]
            ),
          ],
        ],
        2
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }